import { render, staticRenderFns } from "./MaterialView.vue?vue&type=template&id=0a9e683b&scoped=true"
import script from "./MaterialView.vue?vue&type=script&lang=js"
export * from "./MaterialView.vue?vue&type=script&lang=js"
import style0 from "./MaterialView.vue?vue&type=style&index=0&id=0a9e683b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e683b",
  null
  
)

export default component.exports